<template>
  <span style="height: 24px">
    <div style="height: 24px">
      <input 
        :id="permKey" 
        ref="permissionSwitch"
        type="checkbox"
        :class="['glass-switch', inherited ? 'glass-switch-inherited' : '']"
        :checked="checked"
        @change="onCheckboxChange"
      />
      <label :for="permKey"> </label>
    </div>
  </span>
</template>

<style>
input[type="checkbox"].glass-switch {
    position: absolute;
    margin: 8px 0 0 16px;    
    cursor: pointer;
}
input[type="checkbox"].glass-switch + label {
    position: relative;
    padding: 5px 0 0 50px;
    line-height: 2.0em;
    cursor: pointer;
}
input[type="checkbox"].glass-switch + label:before {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    width: 40px;
    height: 24px;
    border-radius: 16px;
    background: #fff;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
}
input[type="checkbox"].glass-switch + label:after {
    content: "";
    position: absolute;
    display: block;
    left: 0px;
    top: 2px;
    width: 20px;
    height: 20px;
    border-radius: 12px;
    background: #fff;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
}

input[type="checkbox"].glass-switch + label:before {
    background: #F2747F;
}
input[type="checkbox"].glass-switch.glass-switch-inherited + label:before  {
  background: #ffffff;
  border: solid 2px #F2747F;
}
input[type="checkbox"].glass-switch + label:after {
    margin-left: 2px;
}
input[type="checkbox"].glass-switch.glass-switch-inherited + label:after {
    border: solid 1px #F2747F;
}

input[type="checkbox"].glass-switch:checked + label:before {
    background: #5BDAB3;
}
input[type="checkbox"].glass-switch.glass-switch-inherited:checked + label:before  {
  background: #ffffff;
  border: solid 2px #5BDAB3;
}
input[type="checkbox"].glass-switch:checked + label:after {
    margin-left: 18px;
}
input[type="checkbox"].glass-switch.glass-switch-inherited:checked + label:after {
    border: solid 1px #5BDAB3;
}

input[type="checkbox"].glass-switch:indeterminate + label:before {
    background: #F5C15B;
}
input[type="checkbox"].glass-switch:indeterminate + label:after {
    margin-left: 9px;
}

</style>

<script>
import { PermissionStateTypes } from '@/store/types'
import formField from '@/mixins/formField'

export default {
  name: "FormPermissionSwitch",
  model: {
    event: 'change'
  },
  mixins: [formField],
  props: {
    value: String,
    field: String,
    permKey: String,
    inherited: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function(newVal, oldVal) {
        this.updateSwitchState(newVal)
      }
    }
  },
  mounted() {
    this.updateSwitchState(this.$props.value)
  },
  computed: {
  },
  methods: {
    updateSwitchState(value) {
      switch(value) {
        case PermissionStateTypes.mixed:
          $(this.$refs.permissionSwitch).prop("indeterminate", true);
          break
        case PermissionStateTypes.allow:
          $(this.$refs.permissionSwitch).prop("indeterminate", false);
          this.$data.checked = true
          break
        case PermissionStateTypes.deny:
          $(this.$refs.permissionSwitch).prop("indeterminate", false);
          this.$data.checked = false
          break
      }
    },
    onCheckboxChange(event) {
      if($(this.$refs.permissionSwitch).prop("indeterminate")) {
        this.$emit('update', PermissionStateTypes.mixed)
        return
      }
      if(event.target.checked)
        this.$emit('update', PermissionStateTypes.allow)
      else
        this.$emit('update', PermissionStateTypes.deny)
    },
    hasError() {
      return this.getFieldError(this.$props.form, this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.form, this.$props.field)
    }
  }
}
</script>